import React from 'react';
import { motion } from 'framer-motion';

const TeamTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'roster', label: 'ROSTER' },
    { id: 'staff', label: 'STAFF' }
  ];

  return (
    <div className="flex gap-6 mb-12">
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`relative px-8 py-2 text-3xl font-morganite tracking-wider transition-all duration-300
            bg-brand-peach text-black rounded-lg
            ${activeTab === tab.id 
              ? 'text-brand-red' 
              : 'hover:text-brand-red'
            }`}
        >
          {tab.label}
          {activeTab === tab.id && (
            <motion.div
              layoutId="activeTab"
              className="absolute bottom-0 left-0 right-0 h-1 bg-brand-red"
              initial={false}
              transition={{ type: "spring", stiffness: 500, damping: 30 }}
            />
          )}
        </button>
      ))}
    </div>
  );
};

export default TeamTabs;